
    import Vue from "vue";
    import Component from "vue-class-component";
    import VisitViewHeader from "@/vue/components/VisitViewHeader.vue";
    import VisitViewDetail from "@/vue/components/VisitViewDetail.vue";
    import ApiClient from "@/utilities/ApiClient";
    import Utils from "@/utilities/Utils";
    import { VisitSearchParameters } from "@/model/VisitSearchParameters";
    import { IVisitSearchResult, VisitSearchResult } from "@/model/VisitSearchResult";
    import { ILookupItem } from "@/model/LookupItem";
    import { IVisit } from "@/model/Visit";

    interface ISearchResponse {
        list: Array<IVisitSearchResult>;
        count: number;
    }

    @Component({ components: { VisitViewHeader, VisitViewDetail } })
    export default class VisitPrint extends Vue {

        async mounted(): Promise<void> {
            const visitID = this.$route.params.visitID ?? Utils.emptyGuidValue;

            const loadVisitorCompanies = async () => { this.visitorCompanyList = await ApiClient.get("/api/visitorCompany/lookups"); }
            const loadRecipients = async () => { this.recipientList = await ApiClient.get(`/api/siteRecipient/lookups?siteID=${Utils.emptyGuidValue}`); }
            await Promise.all([
                this.loadVisit(visitID),
                loadVisitorCompanies(),
                loadRecipients()
            ]);
        }

        visitorCompanyList: Array<ILookupItem> = [];
        recipientList: Array<ILookupItem> = [];
        visitSearchResult: VisitSearchResult = new VisitSearchResult();

        // this is cobbled together from Visits (search) code + VisitDialogue code
        async loadVisit(visitID: string): Promise<void> {
            const parameters = new VisitSearchParameters();
            parameters.id = visitID;
            const response: ISearchResponse = await ApiClient.post("/Api/Visit/Search", parameters);
            if(response.list.length !== 1) {
                console.error("Failed to load visit - ID = ", visitID);
                return;
            }
            const searchResult = response.list[0];
            this.visitSearchResult.update(searchResult);
            // now update result from visit/load (includes answers)
            const visitData: IVisit = await ApiClient.get(`api/visit/Load?id=${this.visitSearchResult.visit.id}`);
            this.visitSearchResult.visit.update(visitData);

            Vue.nextTick(() => {
                // hacky delay to make sure page has properly loaded...
                setTimeout(() => { window.print(); }, 300);
            });
        }
    }
